import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-daily-users',
  templateUrl: './edit-daily-users.component.html',
  styleUrls: ['./edit-daily-users.component.scss']
})
export class EditDailyUsersComponent implements OnInit {

    productId: string | null = null;
    product: any = {
  name_ar: '',
  description: '',
  icon: '',
  order: 0,
  is_active: true
  };
   public arrCoupons: any[] = [];
  public lang : any
errors: any = {};


constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,private language : LanguageService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');
    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

    if (this.productId) {
      this.loadProduct(this.productId);
    }


                     this.apiService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })

  }

// Fetch product details
loadProduct(id: string): void {
  this.apiService.getUsers(id).subscribe({
    next: (res: any) => {
      const data = res.data;

this.product.name_ar = data.name;
      this.product.description = data.description;
      this.product.icon = data.icon;
      this.product.order = data.order;
      this.product.is_active = data.is_active ? true : false;
    },
    error: (err) => {
      console.error('Failed to load category:', err);
      this.toastr.error('Failed to load category details');
    }
  });
}



    onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      this.product.image = event.target.files[0];
    }
  }
  // Update product

  
    updateProduct(): void {
    if (!this.productId) return;

    this.apiService.editUsers(this.productId, this.product).subscribe({
      next: (res) => {
        this.toastr.success('  updated successfully');
        this.router.navigate(['/DAILY_USERS']); // redirect after save
      },
      error: (err) => {
        console.error('Update failed:', err);
        this.toastr.error('Failed to update  ');
      }
    });
  }


}